module.exports = __webpack_public_path__ + "img/answer-c3-5.e43ea7fd.png";